import { render, staticRenderFns } from "./bGalleryViewGold.vue?vue&type=template&id=3a0801b0&scoped=true"
import script from "./bGalleryViewGold.vue?vue&type=script&lang=js"
export * from "./bGalleryViewGold.vue?vue&type=script&lang=js"
import style0 from "./bGalleryViewGold.vue?vue&type=style&index=0&id=3a0801b0&prod&scoped=true&lang=css"
import style1 from "./bGalleryViewGold.vue?vue&type=style&index=1&id=3a0801b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0801b0",
  null
  
)

export default component.exports